import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cascade",
  "use": "cascade-usage",
  "viewBox": "0 0 13 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 17\" id=\"cascade\"><g fill-rule=\"evenodd\"><path d=\"M2.056 6.5A4.449 4.449 0 016.5 2.056c2.45 0 4.444 1.994 4.444 4.444S8.95 10.943 6.5 10.943A4.449 4.449 0 012.056 6.5M6.5 0A6.507 6.507 0 000 6.5c0 3.234 2.376 5.914 5.472 6.41V14H3.015v2.015h6.994v-2.014h-2.48v-1.09C10.623 12.414 13 9.734 13 6.5 13 2.916 10.084 0 6.5 0z\" /><path d=\"M6.536 3.536a3 3 0 100 5.999 3 3 0 000-6z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id